import {SharedListState} from '../../interfaces/shared-list.interface';
import {uniq} from 'lodash';

export const enum SharedListActions {
  SET_STATE = 'SET_STATE',
  TOGGLE_VEHICLE = 'TOGGLE_VEHICLE',
  TOGGLE_ALL_VEHICLES = 'TOGGLE_ALL_VEHICLES',
  UNTOGGLE_ALL_VEHICLES = 'UNTOGGLE_ALL_VEHICLES',
}

export type SharedListAction =
  | ToggleVehicle
  | ToggleAllVehicles
  | UnToggleAllVehicles
  | SetState;

export type Selector<T> = (state: SharedListState) => T;

export class ToggleVehicle {
  readonly type = SharedListActions.TOGGLE_VEHICLE;
  constructor(readonly vehicle: string) {
  }
}

export class ToggleAllVehicles {
  readonly type = SharedListActions.TOGGLE_ALL_VEHICLES;
  constructor(readonly vehicles: string[]) {
  }
}

export class UnToggleAllVehicles {
  readonly type = SharedListActions.UNTOGGLE_ALL_VEHICLES;
  constructor(readonly vehicles: string[]) {
  }
}

export class SetState {
  readonly type = SharedListActions.SET_STATE;
  constructor(readonly state: SharedListState) {
  }
}

export function selectedHasVehicles(state: SharedListState): boolean {
  return state.selectedVehicles.length > 0;
}

export function selectedVehiclesCount(state: SharedListState): number {
  return state.selectedVehicles.length;
}

export function selectedVehicles(state: SharedListState): string[] {
  return state.selectedVehicles;
}

export function sharedListReducer(state: SharedListState, action: SharedListAction): SharedListState {
  switch (action.type) {
  case SharedListActions.SET_STATE: {
    return {...action.state};
  }
  case SharedListActions.TOGGLE_VEHICLE: {
    const selectedVehicleState = selectedVehicles(state);
    const index = selectedVehicleState.findIndex(e => e === action.vehicle);

    if (index === -1) {
      addVehicle(action.vehicle, state);
    } else {
      removeVehicle(index, state);
    }

    return {
      ...state,
      selectedVehicles: state.selectedVehicles,
      selectAll: false
    };
  }
  case SharedListActions.TOGGLE_ALL_VEHICLES: {
    const selectedVehicleState = selectedVehicles(state);
    return {
      ...state,
      selectedVehicles: uniq(selectedVehicleState.concat(action.vehicles)),
      selectAll: true
    };
  }
  case SharedListActions.UNTOGGLE_ALL_VEHICLES: {
    let selectedVehicleState = selectedVehicles(state);
    const vehiclesToToggle = action.vehicles;

    selectedVehicleState = selectedVehicleState.filter(sv => !vehiclesToToggle.map(vtt => vtt).includes(sv));

    return {
      ...state,
      selectedVehicles: selectedVehicleState,
      selectAll: false
    };
  }
  default: {
    return state;
  }
  }
}

function removeVehicle(index: number, state: SharedListState) {
  state.selectedVehicles.splice(index, 1);
}

function addVehicle(uuid: string, state: SharedListState) {
  state.selectedVehicles.push(uuid);
}
